/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Titlemaxlength2Inputs */

const id_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul harus kurang dari 75 karakter`)
};

const ms_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tajuk mesti kurang daripada 75 aksara`)
};

const da_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel skal være mindre end 75 tegn`)
};

const de_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Titel muss weniger als 75 Zeichen lang sein`)
};

const en_us2_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title must be less than 75 characters`)
};

const es_es2_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El título debe tener menos de 75 caracteres`)
};

const es_mx2_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El título debe tener menos de 75 caracteres`)
};

const fil_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang pamagat ay dapat na mas mababa sa 75 character`)
};

const fr_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le titre doit contenir moins de 75 caractères`)
};

const it_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il titolo deve avere meno di 75 caratteri`)
};

const hu_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A címnek 75 karakternél rövidebbnek kell lennie`)
};

const nl_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel moet korter zijn dan 75 tekens`)
};

const no_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tittelen må være mindre enn 75 tegn`)
};

const pl_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tytuł musi mieć mniej niż 75 znaków`)
};

const pt_br2_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title must be less than 75 characters`)
};

const pt_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O título deve ter menos de 75 caracteres`)
};

const ro_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titlul trebuie să aibă mai puțin de 75 de caractere`)
};

const fi_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otsikon on oltava alle 75 merkkiä`)
};

const sv_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titeln måste vara mindre än 75 tecken`)
};

const vi_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu đề phải ít hơn 75 ký tự`)
};

const tr_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlık 75 karakterden az olmalıdır`)
};

const cs_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název musí mít méně než 75 znaků`)
};

const bg_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заглавието трябва да е по-малко от 75 знака`)
};

const ru_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заголовок должен быть менее 75 символов`)
};

const uk_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заголовок має містити менше 75 символів`)
};

const ar_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يجب أن يكون العنوان أقل من 75 حرفًا`)
};

const hi_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षक 75 अक्षर से कम`)
};

const th_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อเรื่องต้องน้อยกว่า 75 ตัวอักษร`)
};

const ja_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトルは75文字未満である必要があります`)
};

const zh_cn2_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title must be less than 75 characters`)
};

const zh_hant1_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title must be less than 75 characters`)
};

const ko_forms_review_titlemaxlength2 = /** @type {(inputs: Forms_Review_Titlemaxlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title must be less than 75 characters`)
};

/**
* | output |
* | --- |
* | "Title must be less than 75 characters" |
*
* @param {Forms_Review_Titlemaxlength2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_titlemaxlength2 = /** @type {((inputs?: Forms_Review_Titlemaxlength2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Titlemaxlength2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_titlemaxlength2(inputs)
	if (locale === "ms") return ms_forms_review_titlemaxlength2(inputs)
	if (locale === "da") return da_forms_review_titlemaxlength2(inputs)
	if (locale === "de") return de_forms_review_titlemaxlength2(inputs)
	if (locale === "en-US") return en_us2_forms_review_titlemaxlength2(inputs)
	if (locale === "es-ES") return es_es2_forms_review_titlemaxlength2(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_titlemaxlength2(inputs)
	if (locale === "fil") return fil_forms_review_titlemaxlength2(inputs)
	if (locale === "fr") return fr_forms_review_titlemaxlength2(inputs)
	if (locale === "it") return it_forms_review_titlemaxlength2(inputs)
	if (locale === "hu") return hu_forms_review_titlemaxlength2(inputs)
	if (locale === "nl") return nl_forms_review_titlemaxlength2(inputs)
	if (locale === "no") return no_forms_review_titlemaxlength2(inputs)
	if (locale === "pl") return pl_forms_review_titlemaxlength2(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_titlemaxlength2(inputs)
	if (locale === "pt") return pt_forms_review_titlemaxlength2(inputs)
	if (locale === "ro") return ro_forms_review_titlemaxlength2(inputs)
	if (locale === "fi") return fi_forms_review_titlemaxlength2(inputs)
	if (locale === "sv") return sv_forms_review_titlemaxlength2(inputs)
	if (locale === "vi") return vi_forms_review_titlemaxlength2(inputs)
	if (locale === "tr") return tr_forms_review_titlemaxlength2(inputs)
	if (locale === "cs") return cs_forms_review_titlemaxlength2(inputs)
	if (locale === "bg") return bg_forms_review_titlemaxlength2(inputs)
	if (locale === "ru") return ru_forms_review_titlemaxlength2(inputs)
	if (locale === "uk") return uk_forms_review_titlemaxlength2(inputs)
	if (locale === "ar") return ar_forms_review_titlemaxlength2(inputs)
	if (locale === "hi") return hi_forms_review_titlemaxlength2(inputs)
	if (locale === "th") return th_forms_review_titlemaxlength2(inputs)
	if (locale === "ja") return ja_forms_review_titlemaxlength2(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_titlemaxlength2(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_titlemaxlength2(inputs)
	return ko_forms_review_titlemaxlength2(inputs)
});
export { forms_review_titlemaxlength2 as "forms.review.titleMaxLength" }